var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.device !== 'desktop')?_c('div',{staticClass:"fixed-phone"},[_c('a',{attrs:{"href":`tel:${_vm.phoneNumber}`}},[_c('img',{staticClass:"img-call",attrs:{"src":_vm.phoneImage,"alt":"phone"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }